/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

/**
 *
 */
import { ProductHelper } from "./Product.helper";
import * as moment from "moment";
import { User } from "../models/User.model";
import { Customer } from "../types/Customer";
import { Quotation } from "../types/Quotation";
import { Item } from "../types/Item";
import { dicoSPR } from "../data/products/spr/dico";
import { ProductSPR } from "../types/ProductSPR";

export class ProductSPRHelper extends ProductHelper {

    public defaultValue: ProductSPR = { 
        beneficiaries: [{}] ,
        samplingInterval: "month"
    };

    public async init(advisor: User, customer: Customer, quotation: Quotation) {
        await this.tarifsXLS.read(require("../data/products/spr/form/tarifs.xls"));
        await this.propositionPDF.read(require("../data/products/spr/form/proposition.pdf"));
        await this.adhesionPDF.read(require("../data/products/spr/form/adhesion.pdf"));
        super.init(advisor, customer, quotation);
    }
    
    public getDico() {
        return dicoSPR;
    }

    public getAnnuitiesAge85(): Item[] {
        this.tarifsXLS.setActiveSheet("Revenus");
        return this.replaceItemsLabel(this.getItems("B4:AE4", true), ",", " ");
    }

    public getAnnuityImmediate(): number {
        if ( this.product && this.product.annuityAge85 ) {
            return this.product.annuityAge85 / 2;
        }
        return null;
    }

    public getContribution(): number {
        if ( this.getAgeAtEffectiveDate() < 35 ) {
            throw new Error("L'adhérent doit avoir au moins 35 ans à la date d'effet");
        }
        this.tarifsXLS.setActiveSheet("Revenus");
        if ( this.product && this.product.annuityAge85 ) {
            const tarifs = this.tarifsXLS.findProductInRanges("B4:AE4", this.product.annuityAge85, "A5:A46", this.getAgeAtEffectiveDate());
            if ( !tarifs ) {
                throw new Error("L'age de l'assuré n'est pas pris en charge pour cette prestation");
            } else {
                return tarifs.v;
            }
        }
        return null;
    }

    public getPeriodicContribution(): number {
        switch (this.product.samplingInterval) {
            case "month":
                return this.round(this.product.contribution);
            case "trimester":
                return this.round(this.product.contribution) * 3;
            default:
                return null;
        }        
    }

    protected getPDFields() { 
        return {
            ...this._getPDFields(),
            ...this._getPDFields("_p2")
        };
    }

    protected _getPDFields(postFix = "") { 
        return {
            ...this.getAdvisorPDFFields(),
            ...this.getCustomerPDFFields(postFix),

            // Date d'effet souhaitée

            ["effectiveDate" + postFix]: moment(this.quotation.effectiveDate).format("MMYYYY"),
            ["effectiveDate_month" + postFix] : moment(this.quotation.effectiveDate).format("MM"),
            ["effectiveDate_year" + postFix]: moment(this.quotation.effectiveDate).format("YYYY"),

            // Mode de prélèvement

            ["product_samplingInterval_month" + postFix]: ( this.product.samplingInterval === "month" ),
            ["product_samplingInterval_trimester" + postFix]: ( this.product.samplingInterval === "trimester" ),

            // Garanties

            ["product_isAnnuityImmediate" + postFix]: ( this.product.annuityImmediate ),
            ["product_annuityImmediate" + postFix]: this.product.annuityImmediate,
            ["product_isAnnuityAge85" + postFix]: ( this.product.annuityAge85 ),
            ["product_annuityAge85" + postFix]: this.product.annuityAge85,

            // Cotisations

            ["product_monthlyContribution" + postFix]: this.round(this.product.contribution),
            ["product_periodicContribution" + postFix]: this.getPeriodicContribution(),

            // Beneficiaries

            ...this.getProductBeneficiariesPDFFields()
        };
    }

}



// WEBPACK FOOTER //
// ./src/helper/ProductSPR.helper.ts